export default __webpack_public_path__ + "static/media/berlin_light.be088800.png";